import * as React from "react";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Typography, useTheme } from "@mui/material";
import ExpandLessIcon from "assets/icons/ExpandLessIcon";
import ExpandMoreIcon from "assets/icons/ExpandMoreIcon";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { formatPrice } from "helpers/dataFormat";
import BagIcon from "assets/icons/BagIcon";
import DebtsIcon from "assets/icons/DebtsIcon";
import ShareHoldersIcon from "assets/icons/ShareHoldersIcon";
import shortid from "shortid";
import SubItemCloseIcon from "assets/icons/SubItemCloseIcon";
import SubItemOpenIcon from "assets/icons/SubItemOpenIcon";
import {
  StyledList,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
  SubItem,
  SubListItemText
} from "./components";
import { useSelector } from "react-redux";

const ListSubItem = ({ data, paddingRight, addBalanceSheetItem }: {
  data: balanceSheetChildType;
  paddingRight: number;
  addBalanceSheetItem: (item: any) => void
}) => {
  //@ts-ignore
  const { openReports } = useSelector((state) => state).appReducer as { openReports: boolean };
  const [open, setOpen] = React.useState(openReports);

  React.useEffect(() => {
    setOpen(openReports);
  }, [openReports]);

  const childPaddingRight = paddingRight + 20;

  const handleClick = () => {
    setOpen(!open);
  };
  if (data.childs) {
    addBalanceSheetItem({
      "عنوان": data.title,
      "مبلغ": Math.abs(data.amount).toLocaleString("en-US")
    });
    return (
      <>
        <StyledListItemButton
          disableRipple
          active={open}
          onClick={handleClick}
          paddingRight={childPaddingRight}
        >
          <StyledListItemIcon>{open ? <SubItemCloseIcon /> : <SubItemOpenIcon />}</StyledListItemIcon>
          <StyledListItemText>
            <Typography variant="body2">{data.title}</Typography>
          </StyledListItemText>
        </StyledListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {data.childs.map((item) => (
              <ListSubItem paddingRight={childPaddingRight} data={item} key={shortid.generate()}
                           addBalanceSheetItem={addBalanceSheetItem} />
            ))}
          </List>
        </Collapse>
      </>
    );
  } else {
    addBalanceSheetItem({
      "عنوان": data.title,
      "مبلغ": Math.abs(data.amount).toLocaleString("en-US")
    });
    return (
      <SubItem paddingRight={childPaddingRight}>
        <SubListItemText>
          <Typography variant="body2">{data.title}</Typography>
        </SubListItemText>
        <PriceComponent price={formatPrice(data.amount)} />
      </SubItem>
    );
  }
};

const ListItem = ({ data, addBalanceSheetItem }: {
  data: balanceSheetChildType;
  addBalanceSheetItem: (item: any) => void
}) => {
  // @ts-ignore
  const { openReports } = useSelector((state) => state).appReducer as { openReports: boolean };
  const [open, setOpen] = React.useState(openReports);

  const handleClick = () => {
    setOpen(!open);
  };
  const theme = useTheme();

  const initialPaddingRight = 16;
  return (
    <StyledList
      sx={{ width: "100%", bgcolor: "background.paper", marginBottom: "10px", padding: 0 }}
      aria-labelledby="nested-list-subheader"
    >
      <StyledListItemButton disableRipple active={open || openReports} onClick={handleClick}>
        {data.title === "دارایی ها" && (
          <>
            <StyledListItemIcon>
              <BagIcon />
            </StyledListItemIcon>
            <StyledListItemText>
              <Typography variant="body1" fontWeight="bold" color={theme.palette.success.main}>
                {data.title}
              </Typography>
            </StyledListItemText>
          </>
        )}
        {data.title === "بدهی ها" && (
          <>
            <StyledListItemIcon>
              <DebtsIcon />
            </StyledListItemIcon>
            <StyledListItemText>
              <Typography variant="body1" fontWeight="bold" color={theme.palette.error.main}>
                {data.title}
              </Typography>
            </StyledListItemText>
          </>
        )}
        {data.title === "حقوق صاحبان سهام" && (
          <>
            <StyledListItemIcon>
              <ShareHoldersIcon />
            </StyledListItemIcon>
            <StyledListItemText>
              <Typography variant="body1" fontWeight="bold" color={theme.palette.primary.main}>
                {data.title}
              </Typography>
            </StyledListItemText>
          </>
        )}

        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </StyledListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {data.childs &&
          data.childs.map((item) => (
            <ListSubItem paddingRight={initialPaddingRight} data={item} key={shortid.generate()}
                         addBalanceSheetItem={addBalanceSheetItem} />
          ))}
        </List>
      </Collapse>
      <SubItem gray>
        <SubListItemText>
          <Typography variant="body2">جمع کل</Typography>
        </SubListItemText>
        <PriceComponent price={formatPrice(data.amount)} />
      </SubItem>
    </StyledList>
  );
};

const BalanceSheetList = ({ data, addBalanceSheetItem }: {
  data: balanceSheetChildType[];
  addBalanceSheetItem: (item: any) => void
}) => {
  return (
    <>
      {data.map((item) => (
        <ListItem data={item} key={shortid.generate()} addBalanceSheetItem={addBalanceSheetItem} />
      ))}
    </>
  );
};

export default BalanceSheetList;
